import React from 'react';
import AppRouter from './routes/AppRouter';
import { BrowserRouter as Router } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { AuthProvider } from './AuthContext'; // Adjust the import path accordingly

const App = () => (
  <AuthProvider> {/* Wrap your app with AuthProvider */}
    <Router>
      <ToastContainer position="top-center" autoClose={3000} />
      <AppRouter />
    </Router>
  </AuthProvider>
);

export default App;
